<template>
  <div
    v-if="Object.keys(getData).length > 0"
    class="festive-banners"
    :class="{ mb16: !removeBottomPadding }"
    :ref="type"
  >
    <div
      v-if="getData?.title"
      class="banners-title mb10 pl12 bold flex-row"
    >
      <span class="lh21 fs-18">{{ getData.title }}</span>
    </div>
    <Carousel
      class="festive-offer-carousel"
      :class="{ removeExtraPadding: removeExtraPadding }"
      :pauseAutoplayOnHover="true"
      :transition="500"
      :itemsToShow="itemsToShow"
      :lottieAnimationFlag="getLottieAnimationData"
    >
      <Slide
        v-for="(item, index) in getData.bannersUrl"
        :key="index"
        :class="{ removeExtraPaddingSlide: removeExtraPadding }"
      >
        <div
          @touchstart.stop
          @touchmove.stop
          @click="goto(item, index)"
          :class="['horz-img-wrap', isAspectRatioPresent && 'asp-ratio' , iscustomClassFromCMSPresent]"
        >
          <template v-if="item.bannerUrl.length > 0">
            <lazy-image
              class="banners-item flex-row fs-20"
              :src="item.bannerUrl"
              :src-placeholder="getPlaceHolderImg"
              :style="{
                borderRadius: borderRadius,
                aspectRatio: `${isAspectRatioPresent || ''}`
              }"
            />
            <VueLottiePlayer
              v-if="animationJson && showLottieControl"
              name="festiveLottie"
              class="ovf-hidden festiveBannerLottie pa festiveFadeAnimation"
              :class="[
                {
                  'fade-in': showLottie,
                },
                {
                  'fade-out': !showLottie,
                },
              ]"
              width="100%"
              height="100%"
              :animationData="animationJson"
              :autoplay="false"
              :loop="loopCount"
              @animControl="(anim) => lottieControlFun(anim , index)"
              :style="{
                borderRadius: borderRadius,
              }"
            />
          </template>
        </div>
        <Observer
          :options="{ rootMargin: '0px' }"
          @intersect="updateCurrentSlide(item, index)"
        />
      </Slide>
      <!-- <template #addons>
        <Pagination v-if="getData.bannersUrl.length > 1" />
      </template> -->
    </Carousel>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>
<script>
import Observer from "../assets/Observer.vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";
import { 
  v2PwaBasePath, 
  staticImgBaseUrl, 
  projectBasePathWithFolder 
} from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import PageNames from "../config/pageNames";
import localStorageFunc from "../helpers/localStorageFunc";
import { keyMapsAction, keyMapsGetter } from "../helpers/storeKeys";
import { defineAsyncComponent } from "vue";

export default {
  name: "FestiveOfferBanners",
  props: ["moduleProps"],
  components: {
    Carousel,
    Slide,
    Pagination,
    Observer,
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  data() {
    return {
      data: [],
      modulePropsData: {},
      itemsToShow: 1.08,
      currentSlide: 0,
      isUpdated: false,
      animationJson: null,
      lottieApiFlag: false,
      lottieUrl: null,
      type: null,
      showLottie: false,
      loopCount: true,
      lottieConfetti: null,
      showLottieControl: true,
      lottiePlayFlag: false,
      lottiePlayCompleteFlag: false,
      removeExtraPadding: false,
      removeBottomPadding: false,
      borderRadius: null,
      iscustomClassFromCMSPresent:"",
      isAspectRatioPresent: false,
      observer:null,
    };
  },
  mounted() {
    this.modulePropsData =
      this.moduleProps != null &&
      this.moduleProps != "null" &&
      this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    this.removeExtraPadding =
      this.modulePropsData?.removeExtraPadding?.trim() == "true";
    this.removeBottomPadding =
      this.modulePropsData?.removeBottomPadding?.trim() == "true";
    this.borderRadius = this.modulePropsData?.borderRadius
      ? this.modulePropsData?.borderRadius?.trim()
      : null;
    this.iscustomClassFromCMSPresent = this.modulePropsData?.customClassFromCMS || false;
    this.isAspectRatioPresent =
      (!!this.modulePropsData?.aspectRatio &&
        this.modulePropsData?.aspectRatio) ||
      this.isAspectRatioPresent;
  },
  unmounted() {
    if("IntersectionObserver" in window && this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    goto(item, index) {
      this.eventFunction(true, {
        category: item?.category || '',
        positionWithinSection: index + 1
      });
      this.scrollOrRedirectCategory(item);
    },
    updateCurrentSlide(item, index) {
      this.eventFunction(false, {
        category: item?.category || '',
        positionWithinSection: index + 1
      });
    },
    eventFunction(isClicked = false, eObj = {}) {
      let preEventObj = {
        ...eObj
      };
      let eventType = isClicked ? "Click" : "festiveBannerImpression";
      let userAction = isClicked ? "Click" : "Impression";
      const eventObj = Utility.amplitudeEventObj(
          userAction, 
          "festive banner", 
          "-1", 
          preEventObj
        );
      setEvents("amplitude", eventType, eventObj);
    },
    scrollOrRedirectCategory(data) {
      const action = this.getData?.action;
      const href = data?.href || '9999';

      const {redirectUrlCategory = ""} = data;
      if(action === "redirect" && redirectUrlCategory){
        window.location.href = projectBasePathWithFolder+'/'+redirectUrlCategory;
        return;
      }

      if(this.isSeparateMenuVariant) {
        let url =
            projectBasePathWithFolder +
            Utility.getMenuCategory() +
            localStorageFunc.storeId() +
            Utility.getUrlQueryString();
        if (
          action === "menu" ||
          action === "MENU_LIST" ||
          action === "PRODUCT_LIST"
        ) {
          url = Utility.addUpdateParam(url, "showSearchModal", false);
          url = Utility.addUpdateParam(url, "scrollTo", href);
          window.location.href = url;
        } 
        else if (action === "edv") {
          const hrefIs = href;
          if(hrefIs == '7'){
            window.location.href = `${v2PwaBasePath}/${action}?type=199`;
          }
          else if(hrefIs == '6'){
            window.location.href = `${v2PwaBasePath}/${action}?type=99`;
          } 
          else{
            window.location.href = `${v2PwaBasePath}/${action}`;
          }
        } 
        else if (
          action === "edvitems" ||
          action === "edvList" ||
          action === "offers"
        ) {
          window.location.href = `${v2PwaBasePath}/${action}`;
        } 
        else if (action === "gamifyWebview" || action === "redirect") {
          window.location.href = `${v2PwaBasePath}/${href}`;
        } 
        else {
          url = Utility.addUpdateParam(url, "showSearchModal", false);
          url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
          window.location.href = url;
        }
        return;
      }

      let currentElem = this.currentElementIdInStore.map((i) => i.categoryId);
      let curElementId = currentElem.includes(Number(href));
      if (curElementId) {
        let scrollTopMargin = 70;//default
        if(this.isAnchorLinkVariant){
          scrollTopMargin = window.screen.width <= 321 ? 70 : 102;
        }
        switch (action) {
          case "menu":
            Utility.scrollUptoTo("element_catg_" + href ,scrollTopMargin);
            break;
          case "MENU_LIST":
            Utility.scrollUptoTo("element_catg_" + href , scrollTopMargin);
            break;
          case "PRODUCT_LIST":
            Utility.scrollUptoTo("element_catg_" + href , scrollTopMargin);
            break;
          default: // set the default scroll to home
            Utility.scrollUptoMenuTop();
            break;
        }
      } else {
        if(action === "edv"){
          const hrefIs = href;
          if(hrefIs == '7'){
            window.location.href = `${v2PwaBasePath}/${action}?type=199`;
          }
          else if(hrefIs == '6'){
            window.location.href = `${v2PwaBasePath}/${action}?type=99`;
          } else{
            window.location.href = `${v2PwaBasePath}/${action}`;
          }
        }
        else if (
          action === "edvitems" ||
          action === "edvList" ||
          action === "offers"
        ) {
          window.location.href = `${v2PwaBasePath}/${action}`;
        } else if (action === "gamifyWebview" || action === "redirect") {
          window.location.href = `${v2PwaBasePath}/${href}`;
        } else {
          Utility.scrollUptoMenuTop();
        }
      }
    },
    setFullscreenViewBox() {
      const container = this.$refs[this.type];
      const svgElement = container?.querySelectorAll("svg");

      if (svgElement.length > 0) {
        svgElement.forEach((ele) => {
          ele.setAttribute("preserveAspectRatio", `none`);
        });
      }

      const imgEle = container?.querySelectorAll("svg .png image");
      if (imgEle.length > 0) {
        imgEle.forEach((ele) => {
          ele.setAttribute("preserveAspectRatio", `none`);
        });
      }
    },
    observeViewport(element) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          try {
            if (entry.isIntersecting) {
                this.lottieConfetti.play();
            } else {
              this.lottieConfetti.pause();
            }
          } catch (error) {
            console.log("error from observeViewport in festive lottie-", error);
            this.showLottie = false;
          }
        });
      });

      this.observer.observe(element);
    },
    lottieControlFun(anim , index) {
      if (index == 0) {
        this.lottieConfetti = anim;
      }
      else{
        return;
      }
    }
  },
  computed: {
    getData() {
      const { type } = this.modulePropsData;
      let tempData = this.$store.state.User?.staticWidgetData;
      let key = type ? type : "";
      let data = [];
      if (key) {
        data = tempData[key] || [];
      }
      if(data.length) {
        data = data[0];
        let bannersUrl = [];
        for(const key in data.props) {
          if(key.includes('banner')) {
            bannersUrl.push(JSON.parse(data.props[key]));
          }
        }
        data = {
          ...data,
          bannersUrl
        };

        const loopCount = data?.props?.loopCount;
        try{
          if(typeof(loopCount) == "string"){
            if(loopCount == "" || loopCount == "false" || loopCount == 0){
              this.loopCount = 0;
            }
            else if(loopCount == 1){
              this.loopCount = false;
            }
            else{
              const loopNumber = Number(loopCount.trim());
              if(loopNumber > 1 ){
                this.loopCount = loopNumber - 1;
              }
            }
          }
          else{
            this.loopCount = true;
          }   
        }
        catch(e){
          console.log("error in hero banner - ",e);
        }

        this.$store.dispatch(keyMapsAction.GET_FESTIVE_LOTTIE_DATA, {
          type: type,
          lottieUrl: data?.cartAnimation || "",
        });

        return data;
      }
      return [];
    },
    isSeparateMenuVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y ||
        (
          Utility.getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_HOME ||
          Utility.getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_HOME_GUEST
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    currentElementIdInStore() {
      return (
        this.$store.state.ProductItems.allCategoryId?.length !== undefined &&
        this.$store.state.ProductItems.allCategoryId
      );
    },
    isAnchorLinkVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.CONTROL
      ) {
        return true;
      } else {
        return false;
      }
    },
    getPlaceHolderImg(){
      const img =  this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.rect;
      const fallBack = staticImgBaseUrl + '/images/global/default-product-img-lg.png'
      return img || fallBack;
    },
    getLottieAnimationData() {
      const { type } = this.modulePropsData;
      const tempData = this.$store.state.User?.festiveBanner;
      let key = type ? type : "";
      let data = {};
      if (key) {
        this.type = key + "_hero";
        data = tempData[key] || {};
      }
      
      if (Object.keys(data)?.length && !this.lottiePlayCompleteFlag) {
        this.animationJson = data;
        if ( this.loopCount === 0) {
          this.showLottie = false;
          this.showLottieControl = false;
        } else {
          this.showLottie = true;
          this.setFullscreenViewBox();
          this.isLottieCompleted;
          return true;
        }
      }
      return false;
    },
    isLottieCompleted() {
      const lottie = this.lottieConfetti;
      const flag = this.$store.state.Location.showLocationPermissionModalShimmerStore;

      if (lottie && !this.lottiePlayFlag && flag == false) {
        this.setFullscreenViewBox();
        this.lottiePlayFlag = true;

        this.observeViewport(this.$refs[this.type]);

        this.lottieConfetti.addEventListener("complete", () => {
          this.showLottie = false;
          this.lottiePlayCompleteFlag = true;
        });
      }
      return true;
    }
  },
};
</script>

